import styled from 'styled-components';
export default styled.a `
	display: flex;
	text-decoration: none;
	color: #0645ad;
	background: none;
`;
